import { connect } from 'react-redux'
import { Link } from 'react-router'
import React, { Component, PropTypes } from 'react'
import LoginForm from 'client/features/session/components/LoginForm.jsx'
import MagicLoginForm from 'client/features/session/components/MagicLoginForm.jsx'
import { LoginRequest, MagicLoginRequest } from 'client/features/session/actions'
import FontAwesome from 'react-fontawesome'
import URLS from 'constant/URLS'

class Login extends Component {

    login(payload, dispatch) {
        dispatch(LoginRequest.post.action({ payload }))
    }

    magicLogin(payload, dispatch) {
        dispatch(MagicLoginRequest.post.action({ payload }))
    }

    render() {
        return (
            <div>
                <div className='text-center'>
                    <h4 className='text-uppercase font-bold m-b-0'>Sign In</h4>
                </div>
                <div className='panel-body'>
                    <LoginForm onSubmit={ this.login }/>
                    <div className='form-group m-t-30 m-b-0'>
                        <div className='col-sm-12'>
                            <Link to={ URLS.session.resetPassword } className='text-muted'>
                                <FontAwesome name='lock' /> Forgot your password?
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

Login.contextTypes = {
    router: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired,
    session: PropTypes.object
}

const mapStateToProps = (state) => {
    const { session } = state
    return {
        session
    }
}

export default connect(mapStateToProps)(Login)


// WEBPACK FOOTER //
// ./src/client/features/session/containers/Login.jsx